import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IProvideLimit } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 发放限额详情接口
 */
export async function queryProvideLimit() {
  let data = {} as IProvideLimit;

  try {
    const { code, context, message } = await Http.get<IProvideLimit>(`${hostUrl}/risk/quota/info`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IProvideLimit;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 发放限额详情接口
 */
export async function updateProvideLimit(params: IProvideLimit) {

  try {
    const { code, message } = await Http.post<IProvideLimit>(`${hostUrl}/risk/quota/config`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}